export default __webpack_public_path__ + "static/download_file-ccf27f23909c0773020a6d99db06f433.png";